import Button from '@/components/atom/Button';
import Dialog, { DialogProps } from '@/components/atom/Dialog';
import DndItem from '@/components/atom/DndItem';
import useDnd from '@/hooks/useDnd';
import { GripVertical } from 'lucide-react';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const itemsMock = [
  { id: 1, name: 'Item 1' },
  { id: 2, name: 'Item 2' },
  { id: 3, name: 'Item 3' },
  { id: 4, name: 'Item 4' },
  { id: 5, name: 'Item 5' },
  { id: 6, name: 'Item 6' },
  { id: 7, name: 'Item 7' },
  { id: 8, name: 'Item 8' },
  { id: 9, name: 'Item 9' },
  { id: 10, name: 'Item 10' },
  { id: 11, name: 'Item 11' },
  { id: 12, name: 'Item 12' },
  { id: 13, name: 'Item 13' },
  { id: 14, name: 'Item 14' },
  { id: 15, name: 'Item 15' },
  { id: 16, name: 'Item 16' },
  { id: 17, name: 'Item 17' },
  { id: 18, name: 'Item 18' },
  { id: 19, name: 'Item 19' },
  { id: 20, name: 'Item 20' },
  { id: 21, name: 'Item 21' },
  { id: 22, name: 'Item 22' },
  { id: 23, name: 'Item 23' },
  { id: 24, name: 'Item 24' },
  { id: 25, name: 'Item 25' },
  { id: 26, name: 'Item 26' },
  { id: 27, name: 'Item 27' },
  { id: 28, name: 'Item 28' },
  { id: 29, name: 'Item 29' },
  { id: 30, name: 'Item 30' },
];

interface DndDialogRef {
  getCurrentItems: () => { id: number; name: string }[];
}

const TestDialog = forwardRef<
  DndDialogRef,
  DialogProps & { movableItems: { id: number; name: string }[] }
>(({ movableItems, ...rest }, ref) => {
  const { items, moveInsertCardHandler } = useDnd(movableItems);

  useImperativeHandle(ref, () => ({
    getCurrentItems: () => items,
  }));

  return (
    <Dialog
      {...rest}
      contentProps={{
        style: {
          width: '700px',
          maxWidth: 'none',
        },
      }}
      footer={
        <>
          <Button>확인</Button>
        </>
      }
    >
      <DndProvider backend={HTML5Backend}>
        <div className="flex flex-col gap-3">
          {items.map((item, index) => (
            <DndItem
              key={item.id}
              index={index}
              moveCardHandler={moveInsertCardHandler}
              className="flex items-center gap-5 rounded-xl border border-gray2 p-3"
            >
              <GripVertical width={24} height={24} />
              <p className="flex min-w-6 flex-shrink-0 items-center justify-center text-h16b">
                {item.id}
              </p>
              <div className="flex flex-1 items-center justify-between gap-2">
                <p className="text-b16r">{item.name}</p>
              </div>
            </DndItem>
          ))}
        </div>
      </DndProvider>
    </Dialog>
  );
});

export default function DndTestPage() {
  const [open, setOpen] = useState(false);
  const dialogRef = useRef<DndDialogRef>(null);

  console.log('dialogRef >>>>', dialogRef.current?.getCurrentItems());

  return (
    <>
      <div>
        {itemsMock.map((item, index) => (
          <div key={index.toString()}>{item.name}</div>
        ))}
      </div>

      <Button onClick={() => setOpen(true)}>클릭!</Button>
      {open && (
        <TestDialog
          ref={dialogRef}
          open={open}
          onOpenChange={setOpen}
          movableItems={itemsMock}
        />
      )}
    </>
  );
}
